(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter-reminder/assets/javascripts/payfooter-reminder.js') >= 0) return;  svs.modules.push('/components/tur/payfooter-reminder/assets/javascripts/payfooter-reminder.js');

'use strict';

function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
svs = svs || {};
svs.tur = svs.tur || {};
const payFooterReminderLog = new svs.core.log.Logger('tur:payfooter_reminder');
var _trackingLabel = new WeakMap();
class PayfooterReminder extends svs.tur.Base {
  constructor() {
    let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      intersectionOptions = _ref.intersectionOptions,
      trackingLabel = _ref.trackingLabel;
    super();
    _classPrivateFieldInitSpec(this, _trackingLabel, void 0);
    this.createDomElements();
    _classPrivateFieldSet(_trackingLabel, this, trackingLabel);
    this._intersectionOptions = intersectionOptions;
    this._payfooterInViewPort = false;
    this._payfooterReminderClicked = false; 

    this.animations = new svs.tur.payfooter_reminder.animations(this.$el, this.$bubble);

    this.clickHandler = this.clickHandler.bind(this);
    this.mouseEnterHandler = this.mouseEnterHandler.bind(this);
    this.mouseLeaveHandler = this.mouseLeaveHandler.bind(this);
  }
  set payfooterInViewPort(state) {
    this._payfooterInViewPort = state;
    if (state) {
      this.hide();
    }
  }
  get payfooterInViewPort() {
    return this._payfooterInViewPort;
  }
  classNames() {
    return ['payfooter-reminder-default', 'payfooter-reminder', 'dots', 'dots-tur'];
  }
  createDomElements() {
    this.$bubble = this.createElement('payfooter-reminder-bubble', 'button');
    this.$bubble.innerHTML = svs.ui.icon.partials.icon({
      icon: 'menu-down',
      color: 'fc-white'
    });
    this.$bubble.setAttribute('title', 'Fortsätt');
    this.$el.appendChild(this.$bubble);
  }
  appendDomElements() {
    if (!this._hasAppended) {
      this.$payfooterEl = document.querySelector('.payfooter');
      document.body.appendChild(this.$el);
      this.addEventListeners();
      this._hasAppended = true;
    }
  }
  removeDomElements() {
    if (this._hasAppended) {
      this.removeEventListeners();
      document.body.removeChild(this.$el);
      this._hasAppended = false;
    }
  }
  addEventListeners() {
    if (this.$payfooterEl) {
      this.observer = new IntersectionObserver(entries => {
        if (entries && entries[0]) {
          this.payfooterInViewPort = entries[0].isIntersecting;
        }
      }, this._intersectionOptions);
      this.observer.observe(this.$payfooterEl);
    }
    this.$bubble.addEventListener('click', this.clickHandler);
    this.$bubble.addEventListener('mouseenter', this.mouseEnterHandler);
    this.$bubble.addEventListener('mouseleave', this.mouseLeaveHandler);
  }
  removeEventListeners() {
    this.$bubble.removeEventListener('click', this.clickHandler);
    this.$bubble.removeEventListener('mouseenter', this.mouseEnterHandler);
    this.$bubble.removeEventListener('mouseleave', this.mouseLeaveHandler);
  }
  clickHandler() {
    this._payfooterReminderClicked = true;
    this.hide(() => {
      if (this.$payfooterEl) {
        const scrollToPosition = this.$payfooterEl.getBoundingClientRect().top - window.innerHeight + this.$payfooterEl.offsetHeight + window.pageYOffset;
        if (scrollToPosition) {
          gsap.to(window, {
            duration: 0.3,
            scrollTo: scrollToPosition
          });
        }
      }
      this._payfooterReminderClicked = false;
    });
    this.trackClick();
  }
  updateTrackingLabel(label) {
    _classPrivateFieldSet(_trackingLabel, this, label);
  }
  trackClick() {
    if (!_classPrivateFieldGet(_trackingLabel, this)) return;
    svs.components.analytics.trackEvent({
      category: 'Wager',
      action: 'Click payfoot reminder',
      opt_label: _classPrivateFieldGet(_trackingLabel, this)
    });
    payFooterReminderLog.debug("Track PayfooterReminder click. Label: \"".concat(_classPrivateFieldGet(_trackingLabel, this), "\""));
  }
  mouseEnterHandler() {
    if (this.tl && this.tl.isActive() && !this._payfooterReminderClicked) {
      this.tl.pause();
    }
  }
  mouseLeaveHandler() {
    if (this.tl && this.tl.paused() && !this._payfooterReminderClicked) {
      if (!this.leaveReminder || this.tl.currentLabel() !== 'hide') {
        this.tl.resume();
      }
    }
  }
  hide(onComplete) {
    if (this._hasAppended) {
      this._payfooterReminderClicked = true;
      this.leaveReminder = false;
      if (this.tl) {
        this.tl.pause();
        const hideTL = gsap.timeline({
          onComplete
        });
        hideTL.add(this.animations.dotsDown().timeScale(3));
        hideTL.add(this.animations.arrowDown().timeScale(1.4));
        hideTL.call(() => {
          if (this.tl) {
            this.tl.progress(1);
          }
        });
        return hideTL;
      }
    }
  }
  show(onComplete) {
    let leaveReminder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    this.leaveReminder = leaveReminder;
    if (!this.tl) {
      const tl = gsap.timeline({
        onStart: () => {
          this.appendDomElements();
        },
        onComplete: () => {
          this.removeDomElements();
          this.tl = null;
          if (onComplete) {
            onComplete.call();
          }
        }
      });
      tl.addLabel('show');
      tl.add(this.animations.dotsUp());
      tl.add(this.animations.arrowUp(), "-=0.8");
      tl.add(this.animations.arrowWiggle());
      tl.add(this.animations.arrowMinimize());
      tl.addLabel('minimize');
      tl.call(() => {
        if (this.leaveReminder) {
          tl.pause();
        }
      });
      tl.addLabel('hide');
      tl.add(this.animations.dotsDown(), "-=0.3");
      tl.add(this.animations.arrowDown(), '+=2');
      this.tl = tl;
    } else {
      if (!this.tl.isActive()) {
        this.tl.restart();
      }
    }
    return this.tl;
  }
}
svs.tur.payfooter_reminder = PayfooterReminder;

 })(window);